'use strict';

/**
 * View for the members listing
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var GroupMembersView = require('modules/community/views/partials/group-members');

var template = require('modules/community/templates/layout/group-members-modal.hbs');

var GroupMembersModalView = ColidoLayoutView.extend({
    template: template,

    regions: {
        groupMembersRegion: '.group-members-region',
    },

    ui: {
        actionClose: '[data-action="close"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    onRender: function() {
        this.groupMembersRegion.show(new GroupMembersView({
            model: this.model,
            groupMemberLimit: false,
            compactStyle: false,
        }));
    },
});

module.exports = GroupMembersModalView;